import React from "react";
import Container from "react-bootstrap/Container"
import Login2 from '../views/Login2'
import Home_Gastos from '../views/Home_Gastos'
import firebaseApp from "../firebase/credenciales";
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth";
const auth = getAuth(firebaseApp);



function CRUD_Gastos(){

    

    const [usuario, setUsuario] = React.useState(null);

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase) {
      setUsuario(usuarioFirebase);
    } else {
      setUsuario(null);
    }
  });
    return(
    <Container fluid>
      {usuario ? <Home_Gastos usuario={usuario}></Home_Gastos>: <Login2 />}
    </Container>
    );
}




export default CRUD_Gastos;